import React, {useState} from 'react';
import Modal from "../../components/modal/modal";
import {Select} from "../../components/ajonjolib/inputs/ajonjolinput";
import {TextInput} from "../../components/input/inputs";
import {toast, ToastTypes} from "../../components/toasts/toast/toast";
import axiosInstance from "../../AxiosInstance";

export default function ConfirmDeleteModal({show, setter, selectedFileId}) {
    const deleteFile = async () => {
        const response = await axiosInstance.delete(`file/${selectedFileId}/`);

        if(response.status === 204) {
            window.location.reload();
        }
        else {
            toast("No es posible eliminar el documento", ToastTypes.ERROR);
        }
    }

    return (
        <Modal show={show} setter={setter} onClick={() => deleteFile()} name={'Eliminar Sustento'} buttonName={'Eliminar'}>
            <div className={'mb-3'}>¿Seguro que deseas eliminar este sustento?</div>
        </Modal>
    )
}